<div class="stepper-wrapper">
  <p-stepper [value]="1" class="basis-[50rem]">
    <p-step-list>
      <p-step [value]="1" [disabled]="true">Maestra Solución</p-step>
      <p-step [value]="2" [disabled]="true">Artículos</p-step>
    </p-step-list>
    <p-step-panels>
      <p-step-panel [value]="1">
        <ng-template #content let-activateCallback="activateCallback">
          <div class="panel-content">
            <div class="flex flex-col">
              <app-custom-table [showRecover]="true" [radioButton]="true" [showCheckbox]="true"
                [isMultipleSelect]="false" [data]="dataMasterSolution" [headers]="masterSolutionHeader"
                [previousFilters]="filters" (onRecoverData)="getMasterSolutionsForSelection()"
                (selectionChange)="selectionChange($event)" (onPageChange)="onPageChange($event)"
                (onFilterChange)="onFilterChange($event)">
              </app-custom-table>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <app-custom-button [width]="'6.5'" [severity]="'success'" [label]="'Siguiente'" [icon]="'pi pi-arrow-right'"
              (onClick)="goToStep(2, activateCallback)">
            </app-custom-button>
          </div>
        </ng-template>
      </p-step-panel>
      <p-step-panel [value]="2">
        <ng-template #content let-activateCallback="activateCallback">
          <div class="panel-content">
            <div class="flex flex-col">
              <app-custom-table [showRecover]="true" [showCheckbox]="true" [isMultipleSelect]="true"
                [data]="dataMasterSolutionDetail" [headers]="masterSolutionDetailHeader"
                [checkBoxAction]="checkboxActions" [previousFilters]="filters" (onPageChange)="onPageChange($event)"
                (onAction)="onAction($event)" (onRecoverData)="getMasterSolutionDetailsForSelection()"
                (onFilterChange)="onFilterChange($event)">
              </app-custom-table>

            </div>
          </div>
          <div class="row justify-content-between row-buttons align-center mb-2">
            <div class="d-flex justify-content-between">
              <app-custom-button [width]="'6.5'" [label]="'Regresar'" [severity]="'danger'" [icon]="'pi pi-arrow-left'"
                (onClick)="goToStep(1, activateCallback)">
              </app-custom-button>
            </div>
          </div>
        </ng-template>
      </p-step-panel>
    </p-step-panels>
  </p-stepper>
</div>